import React, { forwardRef, useState } from 'react';
import {
  ErrorContainer,
  LabelContainer,
  LabelText,
  Loader,
  RightIconContainer,
  StyledInput,
  StyledLabel,
  StyledTextarea,
  TooltipContainer,
  TooltipText,
} from './SmallInput.styles';
import { ReactComponent as InfoIcon } from '../../../../assets/icons/info.svg';
import LoaderGIF from '../../../../assets/gifs/loader.gif';

const SmallInput = forwardRef(
  (
    {
      disabled,
      className,
      label,
      tooltipText,
      hideErrorMessage,
      error,
      placeholder,
      rightIcon,
      rightIconLoader,
      onRightIconClick,
      value,
      onChange,
      type,
      ...inputProps
    },
    ref,
  ) => {
    const [showTooltip, setShowTooltip] = useState(false);
    const [focused, setFocused] = useState(false);

    const onFocus = () => setFocused(true);
    const onBlur = () => {
      setFocused(false);
    };

    const handleKeyDown = e => {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        e.currentTarget.form.requestSubmit();
      }
    };

    return (
      <StyledLabel disabled={disabled} className={className}>
        {label && (
          <LabelContainer>
            <LabelText>{label}</LabelText>
            {tooltipText && (
              <InfoIcon
                width={16}
                height={16}
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
              />
            )}
            {tooltipText && showTooltip && (
              <TooltipContainer>
                <TooltipText>{tooltipText}</TooltipText>
              </TooltipContainer>
            )}
          </LabelContainer>
        )}
        {type === 'textarea' ? (
          <StyledTextarea
            ref={ref}
            placeholder={placeholder}
            type={type}
            value={value}
            onChange={onChange}
            disabled={disabled}
            onFocus={onFocus}
            onBlurCapture={onBlur}
            onKeyDown={handleKeyDown}
            {...inputProps}
          />
        ) : (
          <StyledInput
            ref={ref}
            placeholder={placeholder}
            type="text"
            value={value}
            onChange={onChange}
            disabled={disabled}
            onFocus={onFocus}
            onBlurCapture={onBlur}
            $isFocused={focused}
            $rightIcon={!!rightIcon}
            autoComplete="new-password"
            {...inputProps}
          />
        )}
        {rightIcon && (
          <RightIconContainer onClick={onRightIconClick} $rightIconLoader={!!rightIconLoader}>
            {rightIconLoader ? <Loader src={LoaderGIF} /> : rightIcon}
          </RightIconContainer>
        )}
        {!hideErrorMessage && <ErrorContainer>{error}</ErrorContainer>}
      </StyledLabel>
    );
  },
);

export default SmallInput;
